<template>
  <page-outline :title="pageTitle">
    <!-- Actions principales -->
    <template v-slot:primaryActions>
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        :returnUrl="returnUrl"
        :isBackButton="true"
        :aria-label="$t('common.bck')"
      />
    </template>

    <template slot="pageContent">
      <b-container fluid>
        <b-row>
          <b-col sm="6" class="form-group" v-if="rightsProfile.length > 1 && entityType != 1">
            <label for="id-account">
              {{ $t('common.routing.account_id') }}<span class="color-red"> * </span>
            </label>
            <select class="form-control" id="id-account" v-model="IdAccountSelected" :disabled="mode === 'details' && editMode === false">
              <option :value="account.idAccount" selected v-for="account in rightsProfile" :key="account.idAccount"> {{ account.accountName }} </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group" v-if="rightsProfile.length > 1">
          </b-col>
        </b-row>
        <b-row>
  <!--        <b-col sm="6" class="form-group">-->
  <!--          <form-write-group-label-input v-model="message" isMandatory :disabled="mode === 'details' && editMode === false"-->
  <!--            :inputLabel="$t('common.routing.message')" :placeholderValue="$t('common.routing.message')">-->
  <!--          </form-write-group-label-input>-->
  <!--        </b-col>-->
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-if="flagCACP && (entitiesType == 'responder' || entitiesType == 'decentralised')" v-model="routingName" isMandatory :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.flagCACP.entity_routing_name')" :placeholderValue="$t('common.routing.flagCACP.entity_routing_name')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else-if="flagCACP && (entitiesType == 'requester')" v-model="routingName" isMandatory :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.flagCACP.entity_label')" :placeholderValue="$t('common.routing.flagCACP.entity_label')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else v-model="routingName" isMandatory :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.routing_name_'+entitiesType)" :placeholderValue="$t('common.routing.routing_name_'+entitiesType)">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-if="flagCACP && (entitiesType == 'responder' || entitiesType == 'decentralised')" v-model="routingDescription" :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.flagCACP.entity_routing_description')" :placeholderValue="$t('common.routing.flagCACP.entity_routing_description')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else-if="flagCACP && (entitiesType == 'requester')" v-model="routingDescription" :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.flagCACP.entity_description')" :placeholderValue="$t('common.routing.flagCACP.entity_description')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else v-model="routingDescription" :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.routing_description_'+entitiesType)" :placeholderValue="$t('common.routing.routing_description_'+entitiesType)">
            </form-write-group-label-input>
          </b-col>

  <!--        <b-col sm="6" class="form-group" v-if="false">-->
  <!--          <label>-->
  <!--            {{ $t('common.routing.receiver_type') }}<span class="color-red"> * </span>-->
  <!--          </label>-->
  <!--          <select class="form-control" v-model="receiverType" readonly :class="selectTypeColor" :disabled="mode === 'details' && editMode === false">-->
  <!--&lt;!&ndash;            <option value="" hidden disabled> {{ $t('common.routing.select_receiver_type') }} </option>&ndash;&gt;-->
  <!--            <option value="0" class="color-black-message-details" > {{ $t('common.routing.bic') }} </option>-->
  <!--            <option value="1" class="color-black-message-details" > {{ $t('common.routing.bic_group') }} </option>-->
  <!--          </select>-->
  <!--        </b-col>-->
  <!--        <b-col sm="6" v-if="receiverType == ''"></b-col>-->
          <b-col sm="6" class="form-group" v-if="receiverType == 0 && flagCACP && (entitiesType == 'responder' || entitiesType == 'decentralised')">
            <form-write-group-label-input v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.flagCACP.entity_bic')" :placeholderValue="$t('common.routing.flagCACP.entity_bic')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-else-if="receiverType == 0 && flagCACP && (entitiesType == 'requester')">
            <form-write-group-label-input v-model="receiverId" isMandatory :disabled="mode === 'details'"
              :inputLabel="$t('common.routing.flagCACP.entity_bic')" :placeholderValue="$t('common.routing.flagCACP.entity_bic')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-if="flagCACP && (entitiesType == 'requester')">
            <form-write-group-label-input v-model="BICParticipant" :disabled="true"
              :inputLabel="$t('common.routing.flagCACP.entity_bic_participant')" :placeholderValue="$t('common.routing.flagCACP.entity_bic_participant')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-else-if="receiverType == 0">
            <form-write-group-label-input v-if="entitiesType == 'responder'" v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.receiver_id_responder')" :placeholderValue="$t('common.routing.receiver_id_responder')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else-if="entitiesType == 'requester'" v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.receiver_id_requester')" :placeholderValue="$t('common.routing.receiver_id_requester')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else-if="entitiesType == 'rvm'" v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.receiver_id_rvm')" :placeholderValue="$t('common.routing.receiver_id_rvm')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else-if="entitiesType == 'decentralised'" v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.receiver_id_responder_decentralised')" :placeholderValue="$t('common.routing.receiver_id_responder_decentralised')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.receiver_id')" :placeholderValue="$t('common.routing.receiver_id')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-if="flagCACP && (entitiesType == 'requester')">
            <label for="entity-type-cacp">
              {{ $t('common.routing.flagCACP.entity_type') }}<span class="color-red"> * </span>
            </label>
            <select class="form-control" id="entity-type-cacp" v-model="entityTypeCacp" :disabled="mode === 'details' && editMode === false">
              <option :value="type.name" selected v-for="type in entityTypeCacpList" :key="type.name"> {{ type.name }} </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group" v-if="flagCACP && (entitiesType == 'requester')">
            <label for="entity-group-cacp">
              {{ $t('common.routing.flagCACP.entity_group.title') }}<span class="color-red"> * </span>
            </label>
            <select class="form-control" id="entity-group-cacp" v-model="entityGroupCacp" :disabled="mode === 'details' && editMode === false">
              <option :value="group.id" selected v-for="group in entityGroupCacpList" :key="group.name"> {{ group.name }} </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group" v-if="flagCACP && (entitiesType == 'requester') && mode === 'details'">
            <form-write-group-label-input :value="getDate(creationDate)" :disabled="mode === 'details'"
              :inputLabel="$t('common.routing.flagCACP.creation_date')" :placeholderValue="$t('common.routing.flagCACP.creation_date')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-if="flagCACP && (entitiesType == 'requester') && mode === 'details'">
            <form-write-group-label-input v-if="new Date(modificationDate).getTime() > new Date(creationDate).getTime()" :value="getDate(modificationDate)" :disabled="mode === 'details'"
              :inputLabel="$t('common.routing.flagCACP.modification_date')" :placeholderValue="$t('common.routing.flagCACP.modification_date')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else :disabled="mode === 'details'"
              :inputLabel="$t('common.routing.flagCACP.modification_date')" :placeholderValue="'-'">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-if="flagCACP && (entitiesType == 'requester') && mode === 'details'">
            <form-write-group-label-input v-if="new Date(serviceStartDate).getTime() >= new Date(creationDate).getTime()" :value="getDate(serviceStartDate)" :disabled="mode === 'details'"
              :inputLabel="$t('common.routing.flagCACP.service_start_date')" :placeholderValue="$t('common.routing.flagCACP.service_start_date')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else :disabled="mode === 'details'"
              :inputLabel="$t('common.routing.flagCACP.service_start_date')" :placeholderValue="'-'">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-if="flagCACP && (entitiesType == 'requester') && mode === 'details'">
            <form-write-group-label-input v-if="deactivationDate" :value="getDate(deactivationDate)" :disabled="mode === 'details'"
              :inputLabel="$t('common.routing.flagCACP.deactivation_date')" :placeholderValue="$t('common.routing.flagCACP.deactivation_date')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else :disabled="mode === 'details'"
              :inputLabel="$t('common.routing.flagCACP.deactivation_date')" :placeholderValue="'-'">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-if="flagCACP && (entitiesType === 'responder' || entitiesType === 'decentralised' || entitiesType == 'requester')">
            <form-write-group-label-input v-if="entitiesType === 'responder' || entitiesType === 'decentralised' || entitiesType === 'requester'" v-model="billableBic" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.flagCACP.billable_bic')" :placeholderValue="$t('common.routing.flagCACP.billable_bic')">
            </form-write-group-label-input>
          </b-col>
          <b-col v-if="flagCACP && (entitiesType == 'requester')" sm="6" class="form-group" >
            <label for="activity-proof">
              {{ $t('common.routing.flagCACP.activity_justification_option') }}
            </label>
            <select class="form-control" v-model="activityProof" readonly
                    id="activity-proof"
                    :class="selectTypeColor"
                    :disabled="mode === 'details' && editMode === false">
              <option value="null" hidden disabled> {{ $t('common.routing.select_active') }} </option>
              <option value="1" class="color-black-message-details"> {{ $t('common.routing.active') }} </option>
              <option value="0" class="color-black-message-details"> {{ $t('common.routing.desactivate') }} </option>
            </select>
          </b-col>
          <b-col v-if="flagCACP && (entitiesType == 'requester')" sm="6" class="form-group" >
            <label for="activity-proof-stet">
              {{ $t('common.routing.flagCACP.stet_billing_justification_option') }}
            </label>
            <select class="form-control" v-model="activityProofStet" readonly
                    id="activity-proof-stet"
                    :class="selectTypeColor"
                    :disabled="mode === 'details' && editMode === false">
              <option value="null" hidden disabled> {{ $t('common.routing.select_active') }} </option>
              <option value="1" class="color-black-message-details"> {{ $t('common.routing.active') }} </option>
              <option value="0" class="color-black-message-details"> {{ $t('common.routing.desactivate') }} </option>
            </select>
          </b-col>
          <b-col v-if="flagCACP && (entitiesType == 'requester')" sm="6" class="form-group" >
            <label for="activity-proof-eba">
              {{ $t('common.routing.flagCACP.eba_billing_justification_option') }}
            </label>
            <select class="form-control" v-model="activityProofEba" readonly
                    id="activity-proof-eba"
                    :class="selectTypeColor"
                    :disabled="mode === 'details' && editMode === false">
              <option value="null" hidden disabled> {{ $t('common.routing.select_active') }} </option>
              <option value="1" class="color-black-message-details"> {{ $t('common.routing.active') }} </option>
              <option value="0" class="color-black-message-details"> {{ $t('common.routing.desactivate') }} </option>
            </select>
          </b-col>
          <b-col cols="6" class="form-group" v-if="flagCACP && entitiesType == 'requester'">
            <label>{{ $t('common.routing.flagCACP.subscribed_services_list') }}</label>
            <a id="srvList-picker-link" class="filter-item-content d-flex justify-content-between p-1 pt-2" href="#" style="max-width:calc(100% - 30px)">
              <span :class="{'filter-item-input-complete':statusDisplayList.nb > 0}">{{ statusDisplayList.label }}</span>
              <i class="fa-light fa-chevron-down" size="17px" id="srvList-chevron"></i>
            </a>

            <b-popover target="srvList-picker-link"
                      :title="$t('common.routing.flagCACP.select_subscribed_services')"
                      triggers="focus"
                      :disabled="mode === 'details' && editMode === false"
                      placement="bottom">
            <span v-for="srv in subscribedServices" :key="srv.name">
                <b-form-checkbox
                    v-model="srv.state"
                    :value="1"
                    :unchecked-value="0">
                  <span>{{ srv.label }}</span>
                </b-form-checkbox>
            </span>
            </b-popover>
          </b-col>
          <b-col v-if="flagCACP && (entitiesType == 'requester')" sm="6" class="form-group">
            <form-write-group-label-input v-model="unitDdv" :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.flagCACP.unitary_api_emission_consumer')" :placeholderValue="$t('common.routing.flagCACP.unitary_api_emission_consumer')">
            </form-write-group-label-input>
          </b-col>
          <b-col v-if="flagCACP && (entitiesType == 'requester')" sm="6" class="form-group">
            <form-write-group-label-input v-model="bulkDdv" :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.flagCACP.file_exchange_partner')" :placeholderValue="$t('common.routing.flagCACP.file_exchange_partner')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-if="flagCACP && (entitiesType == 'requester') && mode === 'details'">
            <form-write-group-label-input v-model="statusDo" :disabled="mode === 'details'"
              :inputLabel="$t('common.routing.flagCACP.status')" :placeholderValue="$t('common.routing.flagCACP.status')">
            </form-write-group-label-input>
          </b-col>
          <b-col v-if="flagCACP && (entitiesType === 'responder' || entitiesType === 'decentralised')" sm="6" class="form-group">
            <label for="country">{{ $t('common.routing.flagCACP.country') }}<span style="color: red"> *</span></label>
            <select class="form-control" :disabled="mode === 'details' && editMode === false" v-model="entityCountry" id="country">
              <option value="" disabled selected>{{ $t('common.routing.flagCACP.select_country') }}</option>
              <option
                v-for="country in countries"
                :key="country"
                :value="country">
                {{ $t('countriesAlpha2Code.' + country) }}
              </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group" v-if="receiverType == 0 && entitiesType == 'decentralised'">
            <form-write-group-label-input v-model="memberId" :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.member_id')" :placeholderValue="$t('common.routing.member_id')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" v-if="entityType != 1 && (entityType != 2 || !flagCACP)"></b-col>


          <b-col cols="6" class="form-group" v-else>
            <label v-if="flagCACP && (entitiesType == 'responder' || entitiesType == 'decentralised')">{{ $t('common.routing.flagCACP.eligible_id') }}</label>
            <label v-else>{{ $t('common.global.corporate_identifier_type') }}</label>

            <a id="emailGrp-picker-link" class="filter-item-content d-flex justify-content-between p-1 pt-2" href="#" style="max-width:calc(100% - 30px)">
              <span :class="{'filter-item-input-complete':statusDisplay.nb > 0}">{{ statusDisplay.label }}</span>
              <i class="fa-light fa-chevron-down" size="17px" id="emailGrp-chevron"></i>
            </a>

            <b-popover target="emailGrp-picker-link"
                      :title="$t('common.select_corporate_identifier_type')"
                      triggers="focus"
                       :disabled="mode === 'details' && editMode === false"
                       placement="bottom">
            <span v-for="status in corporateIdentifierType" :key="status.name">
                <b-form-checkbox
                    v-model="status.state"
                    :value="1"
                    :unchecked-value="0">
                  <span>{{ status.label }}</span>
                </b-form-checkbox>
            </span>
            </b-popover>
          </b-col>
          <b-col sm="6" class="form-group" v-if="entitiesType == 'decentralised'">
          </b-col>
          <b-col sm="6" class="form-group" v-if="entitiesType == 'decentralised'">
            <label for="slider-seuil" class="col-form-label">{{ $t('common.routing.acceptable_error_threshold') }}<span class="color-red"> * </span></label>
            <div class="" style="text-align: right;">{{acceptableErrorThreshold}}</div>
            <input :disabled="mode === 'details' && editMode === false" readonly class="range-slider-streammind" :class="sliderColorClass" type="range" min="1" max="101" id="slider-seuil" v-model="acceptableErrorThreshold">
          </b-col>
  <!--        <b-col sm="6" class="form-group" v-else-if="receiverType == 1">-->
  <!--          <label>-->
  <!--            {{ $t('common.routing.bic_group') }}<span class="color-red"> * </span>-->
  <!--          </label>-->
  <!--          <select class="form-control" v-model="IdBICGroup" readonly :class="selectTypeColor" :disabled="mode === 'details' && editMode === false">-->
  <!--            <option value="" hidden disabled> {{ $t('common.routing.select_bic_group') }} </option>-->
  <!--            <option v-for="bic in bicGroupList" :key="bic" :value="bic.IdBicGroup" class="color-black-message-details" > {{ bic.GroupName }} </option>-->
  <!--          </select>-->
  <!--        </b-col>-->
  <!--        <b-col sm="6" v-if="entitiesType == 'rvm'" class="form-group">-->
  <!--          <label>-->
  <!--            {{ $t('common.routing.role') }}<span class="color-red"> * </span>-->
  <!--          </label>-->
  <!--          <select class="form-control" v-model="roleSelected" readonly :class="selectTypeColor" :disabled="mode === 'details' && editMode === false">-->
  <!--            <option value="null" hidden disabled> {{ $t('common.routing.select_config_role') }} </option>-->
  <!--            <option value="0" class="color-black-message-details" > {{ $t('common.routing.role_0') }} </option>-->
  <!--            <option value="1" class="color-black-message-details" > {{ $t('common.routing.role_1') }} </option>-->
  <!--          </select>-->
  <!--        </b-col>-->
          <b-col sm="12">
            <form-accordion :title="$t('common.routing.connector')" :isTitleUpperCase="false" v-if="(entitiesType != 'decentralised')">
  <!--            <button v-if="(editMode|| mode == 'create')" class="btn w-auto px-4 btn-tertiary mb-5" @click="addCertificat">{{ $t('common.security.add_certificat') }}</button>-->
              <b-row v-for="(config, key) in arrayConfig" :key="key">
                <b-col sm="6" class="form-group" v-if="((key == '0' && entityType != '2') || (key == '1' && entityType != '0'))">
                  <label v-if="(key == '0' && entityType == '0') || (key == '1' && entityType == '2')" for="config-type">
                    {{ $t('common.routing.config_type_connector') }}
                   <span class="color-red"> * </span>
                  </label>
                  <label v-else for="config-type">
                    {{ $t('common.routing.config_type_'+key) }}
                   <span class="color-red"> * </span>
                  </label>
                  <select class="form-control" v-model="config.configType" @change="resetConfig(config)" readonly
                    id="config-type"
                    :class="selectTypeColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" hidden disabled> {{ $t('common.routing.select_config_type') }} </option>
                    <option value="NULL" v-if="entitiesType == 'rvm'" class="color-black-message-details"> {{ $t('common.routing.none') }} </option>
                    <!--            <option value="INTERPROCESS" class="color-black-message-details" > {{ $t('common.routing.inter_process') }} </option>-->
                    <option value="MQSERIES" v-if="entitiesType != 'decentralised'" class="color-black-message-details" > {{ $t('common.routing.mqseries') }} </option>
                    <!--            <option value="REMOTEFOLDER" class="color-black-message-details" > {{ $t('common.routing.remote_folder') }} </option>-->
                    <option value="WEBSERVICE" v-if="entitiesType != 'decentralised'" class="color-black-message-details" > {{ $t('common.routing.web_service') }} </option>
                    <option value="FTP" v-if="entitiesType != 'decentralised'" class="color-black-message-details" > {{ $t('common.routing.ftp') }} </option>
                    <option value="S3"v-if="entitiesType == 'decentralised'"  class="color-black-message-details" > {{ $t('common.routing.s3') }} </option>
                    <option v-if="entityType == 2"  value="DATABASE" class="color-black-message-details" > {{ $t('common.routing.database') }} </option>
                  </select>
                </b-col>

                <b-col sm="6" class="form-group" v-if="isMQSeries(config) && key == '1' && entitiesType != 'decentralised' && entityType != '0'">
                  <label v-if="key == '1' && entityType == '2'" for="config-mq">
                    {{ $t('common.routing.config_name_connector') }}
                   <span class="color-red"> * </span>
                  </label>
                  <label v-else for="config-mq">
                    {{ $t('common.routing.config_name') }}
                   <span class="color-red"> * </span>
                  </label>
                  <select class="form-control" v-model="config.configMQSeriesId" readonly
                    id="config-mq"
                    :class="selectMQSeriesColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in mqseriesListSender" :key="index" :value="item.IdConfigRouting" >{{item.Name}}</option>
                  </select>
                </b-col>
                <b-col sm="6" class="form-group" v-else-if="isMQSeries(config) && key == '0' && entitiesType != 'decentralised' && entityType != '2'">
                  <label v-if="key == '0' && entityType == '0'" for="config-mq">
                    {{ $t('common.routing.config_name_connector') }}
                   <span class="color-red"> * </span>
                  </label>
                  <label v-else for="config-mq">
                    {{ $t('common.routing.config_name_'+key) }}
                   <span class="color-red"> * </span>
                  </label>
                  <select class="form-control" v-model="config.configMQSeriesId" readonly
                    id="config-mq"
                    :class="selectMQSeriesColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in mqseriesListReceiver" :key="index" :value="item.IdConfigRouting" >{{item.Name}}</option>
                  </select>
                </b-col>
                <b-col sm="6" class="form-group" v-if="isWebService(config) && key == '1' && entityType != '0'">
                  <label v-if="key == '1' && entityType == '2'" for="config-web">
                    {{ $t('common.routing.config_name_connector') }}
                   <span class="color-red"> * </span>
                  </label>
                  <label v-else for="config-web">
                    {{ $t('common.routing.config_name_'+key) }}
                   <span class="color-red"> * </span>
                  </label>
                  <select class="form-control" v-model="config.configWebServiceId" readonly
                    id="config-web"
                    :class="selectWebServiceColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in webServiceListSender" :key="index" :value="item.IdWebService" >{{item.Name}}</option>
                  </select>
                </b-col>
                <b-col sm="6" class="form-group" v-else-if="isWebService(config) && key == '0' && entitiesType != 'decentralised' && entityType != '2'">
                  <label v-if="key == '0' && entityType == '0'" for="config-web">
                    {{ $t('common.routing.config_name_connector') }}
                   <span class="color-red"> * </span>
                  </label>
                  <label v-else for="config-web">
                    {{ $t('common.routing.config_name_'+key) }}
                   <span class="color-red"> * </span>
                  </label>
                  <select class="form-control" v-model="config.configWebServiceId" readonly
                    id="config-web"
                    :class="selectWebServiceColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in webServiceListReceiver" :key="index" :value="item.IdWebService" >{{item.Name}}</option>
                  </select>
                </b-col>
                <b-col sm="6" class="form-group" v-if="isFTP(config) && key == '1' && entityType != '0'">
                  <label v-if="key == '1' && entityType == '2'" for="config-ftp">
                    {{ $t('common.routing.config_name_connector') }}
                   <span class="color-red"> * </span>
                  </label>
                  <label v-else for="config-ftp">
                    {{ $t('common.routing.config_name_'+key) }}<span class="color-red"> * </span>
                  </label>
                  <select class="form-control" v-model="config.configFTPId" readonly
                    id="config-ftp"
                    :class="selectFTPColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in ftpListSender" :key="index" :value="item.IdFTP" >{{item.Name}}</option>
                  </select>
                </b-col>
                <b-col sm="6" class="form-group" v-else-if="isFTP(config) && key == '0' && entitiesType != 'decentralised' && entityType != '2'">
                  <label v-if="key == '0' && entityType == '0'" for="config-ftp">
                    {{ $t('common.routing.config_name_connector') }}
                   <span class="color-red"> * </span>
                  </label>
                  <label v-else for="config-ftp">
                    {{ $t('common.routing.config_name_'+key) }}
                   <span class="color-red"> * </span>
                  </label>
                  <select class="form-control" v-model="config.configFTPId" readonly
                    id="config-ftp"
                    :class="selectFTPColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in ftpListReceiver" :key="index" :value="item.IdFTP" >{{item.Name}}</option>
                  </select>
                </b-col>
<!--                <b-col sm="6" class="form-group" v-else-if="isS3(config) && key == '1' && entityType == '1' && entitiesType == 'decentralised'">-->
<!--                  <label v-if="key == '1' && entityType == '1'" for="config-web">-->
<!--                    {{ $t('common.routing.config_name_connector') }}-->
<!--                    &lt;!&ndash;                  <span class="color-red"> * </span>&ndash;&gt;-->
<!--                  </label>-->
<!--                  <label v-else for="config-web">-->
<!--                    {{ $t('common.routing.config_name_'+key) }}-->
<!--                    &lt;!&ndash;                  <span class="color-red"> * </span>&ndash;&gt;-->
<!--                  </label>-->
<!--                  <select class="form-control" v-model="config.configS3Id" readonly-->
<!--                          id="config-web"-->
<!--                          :class="selectS3Color"-->
<!--                          :disabled="mode === 'details' && editMode === false">-->
<!--                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>-->
<!--                    <option class="color-black-message-details" v-for="(item, index) in S3ListReceiver" :key="index" :value="item.IdConfigS3" >{{item.ConfigName}}</option>-->
<!--                  </select>-->
<!--                </b-col>-->
<!--                <b-col sm="6" class="form-group" v-if="entityType == '0' && key == 0 && arrayConfig[1].configType == 'WEBSERVICE' && connectorHeaderExist()">-->
<!--                  <label for="routing-auth">-->
<!--                    {{ $t('common.routing.authentification') }}-->
<!--  &lt;!&ndash;                  <span class="color-red"> * </span>&ndash;&gt;-->
<!--                  </label>-->
<!--                  <select class="form-control" disabled id="routing-auth">-->
<!--                    <option value="null" selected > {{ $t('common.routing.JWT') }} </option>-->
<!--                  </select>-->
<!--                </b-col>-->
  <!--              <b-col sm="5"></b-col>-->
  <!--              <b-col sm="5"></b-col>-->
  <!--              <b-col sm="2">-->
  <!--                <button v-if="(editMode|| mode == 'create') && arrayConfig.length > 1" class="btn w-auto px-4 btn-tertiary" @click="removeConfig(key, config.IdMessageRouting)">{{ $t('common.security.remove_certificat') }}</button>-->
  <!--              </b-col>-->
              </b-row>

            </form-accordion>
          </b-col>
          <b-col sm="12" v-if="OldCertIdentifier != '' && entityType == '0'">
            <form-accordion :title="$t('common.routing.authentification_certification')" :isTitleUpperCase="false">
              <b-row>
                <b-col sm="6" class="form-group">
                  <form-write-group-label-input v-model="CertIdentifier" isMandatory :disabled="mode === 'details' && editMode === false"
                    :inputLabel="$t('common.routing.certificat_identifier')" :placeholderValue="$t('common.routing.certificat_identifier')">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
          </b-col>
<!--          <b-col sm="12" v-if="entityType == '0'  && connectorHeaderExist()">-->
<!--            <form-accordion :title="$t('common.routing.authentification_header')" :isTitleUpperCase="false">-->
<!--              <b-row>-->
<!--                <b-col sm="6" class="form-group">-->
<!--                  <form-write-group-label-input v-model="HeaderValue" isMandatory :disabled="mode === 'details' && editMode === false"-->
<!--                    :inputLabel="$t('common.routing.authentification_header_value')" :placeholderValue="$t('common.routing.authentification_header_value')">-->
<!--                  </form-write-group-label-input>-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--            </form-accordion>-->
<!--          </b-col>-->
          <b-col sm="6" class="form-group" >
            <label v-if="flagCACP && (entitiesType == 'responder' || entitiesType == 'decentralised' || entitiesType == 'requester')" for="config-type-active">
              {{ $t('common.routing.flagCACP.activity') }}
              <span class="color-red"> * </span>
            </label>
            <label v-else for="config-type-active">
              {{ $t('common.routing.config_active') }}
              <span class="color-red"> * </span>
            </label>
            <select class="form-control" v-model="active" readonly
                    id="config-type-active"
                    :aria-label="flagCACP && (entitiesType == 'responder' || entitiesType == 'decentralised' || entitiesType == 'requester') ? $t('common.routing.flagCACP.activity') : $t('common.routing.config_active')"
                    :class="selectTypeColor"
                    :disabled="mode === 'details' && editMode === false">
              <option value="null" hidden disabled> {{ $t('common.routing.select_active') }} </option>
              <option value="1" class="color-black-message-details"> {{ $t('common.routing.active') }} </option>
              <option value="0" class="color-black-message-details"> {{ $t('common.routing.desactivate') }} </option>
            </select>
          </b-col>
        </b-row>
      </b-container>
    </template>

    <!-- Actions du bas de page -->
    <template v-slot:bottomActions>
      <!-- Bouton Sauvegarder (mode création) -->
      <div v-if="(mode === 'create' && demo)">
        <app-button
            v-if="isFormValid"
            :text="$t('common.sve')"
            icon="fa-light fa-save"
            variant="primary"
            @click="createMessageRouting">
        </app-button>

        <app-button
            v-else
            :text="$t('common.sve')"
            icon="fa-light fa-save"
            variant="primary"
            :disabled="true">
        </app-button>
      </div>



      <!-- Bouton Modifier (mode détails) -->
      <app-button
        v-if="mode === 'details' && editMode === false && canEditMessage && demo"
        :text="$t('administration.edit')"
        icon="fa-light fa-pencil"
        variant="primary"
        @click="editModeActivate">
      </app-button>

      <!-- Bouton Supprimer (mode détails) -->
      <app-button
        v-if="mode === 'details' && editMode === false && canDeleteMessage && demo"
        :text="$t('rights.delete')"
        icon="fa-light fa-trash"
        variant="danger"
        @click="deleteMessageRouting">
      </app-button>

      <!-- Bouton Sauvegarder (mode édition) -->
      <div v-if="canEditMessage && (mode === 'details' && editMode === true && demo)">
        <app-button
            v-if="isFormValid"
            :text="$t('common.sve')"
            icon="fa-light fa-save"
            variant="primary"
            @click="editMessageRouting">
        </app-button>

        <app-button
            v-else
            :text="$t('common.sve')"
            icon="fa-light fa-save"
            variant="primary"
            :disabled="true">
        </app-button>
      </div>

    </template>
  </page-outline>
</template>

<script>

import conf from '../../config/config.dev.js'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import AppButton from '@/components/common/AppButton.vue'
import {errorMessageAlert} from '@/helpers/alert'

import {loadPage} from '@/helpers/routing'
import FormAccordion from "@/components/common/FormAccordion.vue"
import {elements} from "canvg"
import alpha2Country from "../../data/alpha2Country.json"
import moment from "moment-timezone"

export default {
  name: 'MessageDetails',
  components: {
    FormAccordion,
    'app-button': AppButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    role: {
      type: String,
      default: "0"
    },
    type: {
      type: String,
      default: "0"
    },
    entitiesType: {
    },
    tabName: {
    }
  },
  computed: {
    isFormValid () {
      const inCfg = this.arrayConfig[0] || {};
      const outCfg = this.arrayConfig[1] || {};

      // … (tes checks métiers déjà en place: receiverId, routingName, etc.)

      const inType  = inCfg.configType || 'null';
      const outType = outCfg.configType || 'null';

      // Au moins un côté doit être rempli
      if ((inType === 'null' || inType === 'NULL') && (outType === 'null' || outType === 'NULL')) return false;

      // Règle #1 : si les deux côtés sont présents, ils doivent matcher
      if (inType !== 'null' && outType !== 'null' && inType !== 'NULL' && outType !== 'NULL' && inType !== outType) return false;

      // Règle MQSeries : si MQSeries est utilisé d'un côté, il doit l'être des deux côtés
      if (inType === 'MQSERIES' && outType !== 'MQSERIES') return false;
      if (outType === 'MQSERIES' && inType !== 'MQSERIES') return false;

      // Helper: vérifier que l'id correspondant est bien renseigné pour un cfg
      const hasIdFor = (cfg) => {
        switch (cfg.configType) {
          case 'WEBSERVICE': return !!cfg.configWebServiceId;
          case 'MQSERIES':   return !!cfg.configMQSeriesId;
          case 'FTP':        return !!cfg.configFTPId;
          case 'S3':         return !!cfg.configS3Id;
          case 'DATABASE':   return true; // pas d’id unitaire côté UI
          case 'NULL':       return true; // explicitement aucun
          default:           return false;
        }
      };


      // - Tous les champs obligatoires
      if (this.entitiesType === 'requester'){
        if (this.routingName === '') return false;
        if (this.receiverId === '') return false;
        if (this.entityTypeCacp === '') return false;
        if (this.entityGroupCacp === '') return false;
        if (this.billableBic === '') return false;
      }
      if (this.entitiesType === 'responder'){
        if (this.routingName === '') return false;
        if (this.receiverId === '') return false;
        if (this.billableBic === '') return false;
        if (this.entityCountry === '') return false;
      }
      if (this.entitiesType === 'decentralised'){
        if (this.routingName === '') return false;
        if (this.receiverId === '') return false;
        if (this.billableBic === '') return false;
        if (this.entityCountry === '') return false;
      }
      if (this.entitiesType === 'rvm'){
        if (this.routingName === '') return false;
        if (this.receiverId === '') return false;
      }

      // Règle #2 : OK si uniquement WebService en entrée
      if (inType === 'WEBSERVICE' && hasIdFor(inCfg) && outType === 'null') {
        return true;
      }
      if (outType === 'WEBSERVICE' && hasIdFor(outCfg) && inType === 'null') {
        return true;
      }

      // Cas général :
      // - si un seul côté est défini (non-WS entrée), on exige l’autre aussi
      if (this.entitiesType !== 'decentralised') {
        if (inType !== 'null' && outType === 'null') return false;
        if (outType !== 'null' && inType === 'null') return false;
      }
      // - types égaux (testé plus haut) ET chaque côté a son id
      if (this.entitiesType === 'rvm'){
        if (!hasIdFor(inCfg)) return false;
        if (!hasIdFor(outCfg)) return false;
      }

      // Exigence spécifique décentralisé
      if (this.entitiesType === 'decentralised' && this.acceptableErrorThreshold === 0) return false;

      return true;
    },
    sliderColorClass () {
      return 'RTP-slider'
    },
    statusDisplay () {
      let realCorporateIdentifierType = Object.values(this.corporateIdentifierType).filter(status => status.state === 1)
      if (realCorporateIdentifierType.length === 0) {
        if (this.flagCACP && (this.entitiesType === 'responder' || this.entitiesType === 'decentralised')) {
          return {
            label: this.$t('common.routing.flagCACP.eligible_id_selected_none'),
            nb: 0
          }
        } else {
          return {
            label: this.$t('filter.selected_corporate_identifier_type_none'),
            nb: 0
          }
        }
      } else if (realCorporateIdentifierType.length === 1) {
        return {
          label: realCorporateIdentifierType[0].label,
          nb: 1
        }
      } else {
        if (this.flagCACP && (this.entitiesType === 'responder' || this.entitiesType === 'decentralised')) {
          return {
            label: this.$t('common.routing.flagCACP.eligible_id_selected_many', {nbStatus: realCorporateIdentifierType.length}),
          }
        } else {
          return {
            label: this.$t('filter.selected_corporate_identifier_type_many', {nbStatus: realCorporateIdentifierType.length}),
          }
        }
      }
    },
    statusDisplayList () {
      let realSubscribedServices = Object.values(this.subscribedServices).filter(srv => srv.state === 1)
      if (realSubscribedServices.length === 0) {
        return {
          label: this.$t('common.routing.flagCACP.no_subscribed_service_selected'),
          nb: 0
        }
      } else if (realSubscribedServices.length === 1) {
        return {
          label: realSubscribedServices[0].label,
          nb: 1
        }
      } else {
        return {
          label: this.$t('common.routing.flagCACP.multiple_subscribed_services_selected', {nbSrv: realSubscribedServices.length}),
        }
      }
    },
    canDeleteMessage () {
      return this.$engine.firstOn().rights.rightIs('messageRoutingConfig_delete', true)
    },
    canEditMessage () {
      return this.$engine.firstOn().rights.rightIs('messageRoutingConfig_edit', true)
    },
    configId () {
      switch (this.configType) {
        case 'INTERPROCESS':
          return this.configInterProcessId
        case 'MQSERIES':
          return this.configMQSeriesId
        case 'REMOTEFOLDER':
          return this.configRemoteFolderId
        case 'FTP':
          return this.configFTPId
        case 'S3':
          return this.configS3Id
        default:
          return this.configWebServiceId
      }
    },
    pageTitle () {
      return this.mode === 'details' ? this.$t('Webheader.message_details') : this.$t('Webheader.message_add')
    },
    selectMQSeriesColor () {
      return this.configMQSeriesId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectTypeColor () {
      return this.configType === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectWebServiceColor () {
      return this.configWebServiceId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectFTPColor () {
      return this.configWebServiceId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
  },
  data () {
    return {
      acceptableErrorThreshold: 101,
      flagCACP: conf.visual === 'CACP',
      selectNull0: false,
      selectNull1: false,
      activateSpinner: false,
      corporateIdentifierType: {
        BANK: {
          label: this.$t('tracking.select.identifiers.BANK.label'),
          value: 1,
          state: 0
        },
        CBID: {
          label: this.$t('tracking.select.identifiers.CBID.label'),
          value: 2,
          state: 0
        },
        CHID: {
          label: this.$t('tracking.select.identifiers.CHID.label'),
          value: 3,
          state: 0
        },
        CINC: {
          label: this.$t('tracking.select.identifiers.CINC.label'),
          value: 4,
          state: 0
        },
        COID: {
          label: this.$t('tracking.select.identifiers.COID.label'),
          value: 5,
          state: 0
        },
        CUST: {
          label: this.$t('tracking.select.identifiers.CUST.label'),
          value: 6,
          state: 0
        },
        DUNS: {
          label: this.$t('tracking.select.identifiers.DUNS.label'),
          value: 7,
          state: 0
        },
        EMPL: {
          label: this.$t('tracking.select.identifiers.EMPL.label'),
          value: 8,
          state: 0
        },
        GS1G: {
          label: this.$t('tracking.select.identifiers.GS1G.label'),
          value: 9,
          state: 0
        },
        SREN: {
          label: this.$t('tracking.select.identifiers.SREN.label'),
          value: 10,
          state: 0
        },
        SRET: {
          label: this.$t('tracking.select.identifiers.SRET.label'),
          value: 11,
          state: 0
        },
        TXID: {
          label: this.$t('tracking.select.identifiers.TXID.label'),
          value: 12,
          state: 0
        },
        BDID: {
          label: this.$t('tracking.select.identifiers.BDID.label'),
          value: 13,
          state: 0
        },
        BOID: {
          label: this.$t('tracking.select.identifiers.BOID.label'),
          value: 14,
          state: 0
        },
        LEIC: {
          label: this.$t('tracking.select.identifiers.LEIC.label'),
          value: 15,
          state: 0
        },
        EUID: {
          label: this.$t('tracking.select.identifiers.EUID.label'),
          value: 16,
          state: 0
        },
        BICC: {
          label: this.$t('tracking.select.identifiers.BICC.label'),
          value: 17,
          state: 0
        },
        PTRY: {
          label: this.$t('tracking.select.identifiers.PTRY.label'),
          value: 18,
          state: 0
        },
        USTR: {
          label: this.$t('tracking.select.identifiers.USTR.label'),
          value: 18,
          state: 0
        }
      },
      arrayConfig: [{
        configInterProcessId: '',
        configMQSeriesId: '',
        configFTPId: '',
        configRemoteFolderId: '',
        configType: 'null',
        configWebServiceId: '',
        configS3Id: '',
      },
      {
        configInterProcessId: '',
        configMQSeriesId: '',
        configFTPId: '',
        configRemoteFolderId: '',
        configType: 'null',
        configWebServiceId: '',
        configS3Id: '',
      }],
      editMode: false,
      idFormat: 'null',
      idStandard: 'null',
      formatList: [],
      interProcessList: [],
      bicGroupList: [],
      BIC: '',
      billableBic: '',
      countries: alpha2Country.countries.reverse(),
      entityCountry: '',
      entityGroupCacp: '',
      entityGroupCacpList: [],
      entityTypeCacp: '',
      entityTypeCacpList: [
        { name: this.$t('common.routing.flagCACP.group_entity') },
        { name: this.$t('common.routing.flagCACP.external_group_clients') },
        { name: this.$t('common.routing.flagCACP.external') }
      ],
      creationDate: '',
      modificationDate: '',
      serviceStartDate: '',
      deactivationDate: '',
      activityProof: '',
      activityProofStet: '',
      activityProofEba: '',
      subscribedServices: {
        UE: {
          label: this.$t('common.routing.flagCACP.unitary_emission'),
          value: 1,
          state: 0
        },
        ME: {
          label: this.$t('common.routing.flagCACP.mass_emission'),
          value: 2,
          state: 0
        },
        CR: {
          label: this.$t('common.routing.flagCACP.centralized_reception'),
          value: 3,
          state: 0
        },
        DR: {
          label: this.$t('common.routing.flagCACP.decentralized_reception'),
          value: 4,
          state: 0
        }
      },
      unitDdv: '',
      bulkDdv: '',
      statusDo: '',
      IdBICGroup: '',
      message: '',
      receiverType: 0,
      demo: true,
      routingName: '',
      active: '',
      CertIdentifier: '',
      OldCertIdentifier: '',
      HeaderValue: '',
      IdAccountSelected: '',
      OldHeaderValue: '',
      routingDescription: '',
      IdMessageRouting: '',
      mqseriesListSender: [],
      mqseriesListReceiver: [],
      webServiceListSender: [],
      webServiceListReceiver: [],
      S3ListSender: [],
      S3ListReceiver: [],
      ftpListSender: [],
      ftpListReceiver: [],
      rightsProfile: [],
      receiverId: '',
      BICParticipant: '',
      memberId: '',
      remoteFolderList: [],
      returnUrl: '',
      entityType: '',
      savedMessage: [],
      arrayIdMessageRouting: [],
      standardList: [{
        IdStandard: 1,
        Name: 'SRTP'
      }, {
        IdStandard: 2,
        Name: 'HRTP'
      }],
      data: {
        sender: {
          mqseries: [],
          webservice: [],
          S3: [],
          interprocess: [],
          remotefolder: []
        },

        receiver: {
          mqseries: [],
          webservice: [],
          S3: [],
          interprocess: [],
          remotefolder: []
        }
      },
      roleSelected: 0,
      typeSelected: 0,
      timezone: '+00:00'
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    this.getUrl()
    this.roleSelected = this.role
    this.typeSelected = this.type
    if(this.entitiesType == 'requester'){
      this.typeSelected = 0
      this.roleSelected = 1
    }
    if(this.entitiesType == 'responder'){
      this.typeSelected = 1
      this.roleSelected = 0
    }


    this.roleSelected = this.role
    this.typeSelected = this.type
    if(this.entitiesType == 'decentralised'){
      this.roleSelected = 0
      this.getS3Configs()
    }
    this.getBicGroup()
    this.activateSpinner = true

    // this.getFormat()

    if (this.mode === 'details') {
      this.savedMessage = this.$engine.firstOn().routing.message.clickedMessage
      this.fillFields()
      this.$engine.firstOn().routing.message.clickedMessage = {}
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false

    if (this.entityType == 2){
      if (this.arrayConfig[0].configType === 'DATABASE' || this.arrayConfig[1].configType === 'DATABASE'){
        this.arrayConfig[0].configType = 'DATABASE'
        this.arrayConfig[1].configType = 'DATABASE'
      }
    }

    if(this.mode == 'create'){
      this.active = "1"
    }
    if(this.flagCACP && this.entitiesType === 'requester' && this.mode == 'create'){
      this.activityProof = "0"
      this.activityProofStet = "0"
      this.activityProofEba = "0"
    }
    if(this.flagCACP && this.entitiesType === 'requester' && this.mode == 'details'){
      if (this.deactivationDate !== '') {
        this.statusDo = this.$t('common.routing.flagCACP.deactivated')
      } else if (this.serviceStartDate !== '') {
        this.statusDo = this.$t('common.routing.flagCACP.in_service')
      } else {
        this.statusDo = this.$t('common.routing.flagCACP.created')
      }
    }

    if (this.flagCACP && this.entitiesType === 'requester') {
      this.getEntityGroup()
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
    roleSelected(){
      this.getMQSeriesConfigs()
      this.getWebServiceConfigs()
      this.getS3Configs()
      this.getRightsProfile()
      // this.getFTPConfigs()
      this.selectRole()
    }
  },
  methods: {
    validateFormOrAlert () {
      if (this.isFormValid) return true
      // Montre une seule alerte ciblée selon le premier critère manquant
      if (!this.receiverId) return this.okMessageBox(this.$t('common.routing.receiver_id_missing'))
      // ... (le reste de tes messages)
      return false
    },
    resetConfig (config) {
      config.configFTPId = ""
      config.configMQSeriesId = ""
      config.configInterProcessId = ""
      config.configRemoteFolderId = ""
      config.configWebServiceId = ""
    },
    isInterProcess (config) {
      return config.configType === 'INTERPROCESS'
    },
    isMQSeries (config) {
      return config.configType === 'MQSERIES'
    },
    isRemoteFolder (config) {
      return config.configType === 'REMOTEFOLDER'
    },
    isWebService (config) {
      return config.configType === 'WEBSERVICE'
    },
    isS3 (config) {
      return config.configType === 'S3'
    },
    isFTP (config) {
      return config.configType === 'FTP'
    },
    addCertificat (){
      this.arrayConfig.push({
        configInterProcessId: 'null',
        configMQSeriesId: 'null',
        configFTPId: 'null',
        configRemoteFolderId: 'null',
        configType: 'null',
        configWebServiceId: 'null',
      })
    },
    getEntityGroup () {
      let params = {}
      let that = this
      // Vérifier si entityGroup existe avant de l'utiliser
      if (this.$engine.firstOn() && this.$engine.firstOn().entityGroup) {
        this.$engine.firstOn().entityGroup.getEntityGroup(params).then((resp) => {
          this.entityGroupCacpList = resp.data.EntityGroup.map(entityGroup => ({
            id: entityGroup.IdEntityGroup,
            name: entityGroup.Name
          }))
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    removeConfig (key, IdMessageRouting) {

      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.message_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdMessageRouting: IdMessageRouting
              }

              that.arrayConfig.splice(key , 1)
              that.arrayIdMessageRouting.splice(key , 1)

              that.$engine.firstOn().routing.message.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.message_deleted'))
                loadPage(that, {url: this.returnUrl})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    selectRole () {
      if (this.entitiesType === 'rvm'){
        if(this.roleSelected == 0){
          this.typeSelected = 0
        }
        if(this.roleSelected == 1){
          this.typeSelected = 1
        }
      }

      this.mqseriesListSender = this.data.sender.mqseries
      this.mqseriesListReceiver = this.data.receiver.mqseries
      this.webServiceListSender = this.data.sender.webservice
      this.webServiceListReceiver = this.data.receiver.webservice
      this.S3ListSender = this.data.sender.S3
      this.S3ListReceiver = this.data.receiver.S3
      this.ftpListSender = this.data.sender.ftp
      this.ftpListReceiver = this.data.receiver.ftp
    },
    createMessageRouting () {
      if (!this.validateFormOrAlert()) return
      let that = this


      if (this.entityType == 2){
        if (this.arrayConfig[0].configType === 'DATABASE' || this.arrayConfig[1].configType === 'DATABASE'){
          this.arrayConfig[0].configType = 'DATABASE'
          this.arrayConfig[1].configType = 'DATABASE'
        }
      }

      if (this.formHasError()) {
        return
      }

      let configType

      if (this.entityType == 0){
        configType = this.arrayConfig[0].configType
      }

      if (this.entityType == 1){
        configType = this.arrayConfig[1].configType
      }

      if (this.entityType == 2){
        configType = this.arrayConfig[1].configType
      }

      if (this.entityType == 1 && this.entitiesType == 'decentralised'){
        configType = this.arrayConfig[1].configType
      }

      if (this.entitiesType === 'rvm') {
        if (this.arrayConfig[0].configType === 'WEBSERVICE' && this.arrayConfig[1].configType === 'null') {
          configType = 'WEBSERVICE'
        }
      }

      let params = {
        IdAccountSelected: this.IdAccountSelected,
        Type: this.typeSelected,
        Role: this.roleSelected,
        Name: this.routingName,
        Active: this.active,
        CertIdentifier: this.CertIdentifier,
        HeaderValue: this.HeaderValue,
        Description: this.routingDescription,
        ReceiverId: this.receiverId,
        MemberId: this.memberId,
        AcceptableErrorThreshold: this.acceptableErrorThreshold,
        RoutingType: configType,
        BIC: this.BIC,
        IdBICGroup: this.IdBICGroup,
        entityType: this.entityType,
        CorporateIdentifierType: Object.values(this.corporateIdentifierType)
            .filter(status => status.state === 1)
            .map(item => item.value)
            .join(';'),
        BillableBic: this.billableBic,
        EntityCountry: this.entityCountry,
        EntityGroupCacp: this.entityGroupCacp,
        EntityTypeCacp: this.entityTypeCacp,
        ActivityProof: this.activityProof,
        ActivityProofStet: this.activityProofStet,
        ActivityProofEba: this.activityProofEba,
        SubscribedServices: Object.values(this.subscribedServices)
            .filter(srv => srv.state === 1)
            .map(item => item.value)
            .join(';'),
        UnitDdv: this.unitDdv,
        BulkDdv: this.bulkDdv
      }

      if (this.arrayConfig.entitiesType !== 'rvm'){
        params.Type = this.type
        params.Role = this.role
      }



      switch (configType) {
        case 'INTERPROCESS':
          params.IdConfigInput = this.arrayConfig[0].configInterProcessId
          params.IdConfigOutput = this.arrayConfig[1].configInterProcessId
          break
        case 'MQSERIES':
          params.IdConfigInput = this.arrayConfig[0].configMQSeriesId
          params.IdConfigOutput = this.arrayConfig[1].configMQSeriesId
          break
        case 'REMOTEFOLDER':
          params.IdConfigInput = this.arrayConfig[0].configRemoteFolderId
          params.IdConfigOutput = this.arrayConfig[1].configRemoteFolderId
          break
        case 'WEBSERVICE':
          params.IdConfigInput = this.arrayConfig[0].configWebServiceId
          params.IdConfigOutput = this.arrayConfig[1].configWebServiceId
          break
        case 'S3':
          params.IdConfigOutput = this.arrayConfig[1].configS3Id
          break
        default:
          break
      }

      this.$engine.firstOn().routing.message.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.message_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return loadPage(that, {url: that.returnUrl})
              }
            }
          ]
        })
      })
      .catch(e => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          let msgError = errors.map(error => error.errorDescription).join('<br>')
          that.okMessageBoxError(msgError)
        } else {
          errorMessageAlert(e, that, that.$i18n)
          that.okMessageBox(that.$t('common.routing.message_addition_error'))
        }
      })
    },
    deleteMessageRouting () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.message_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdMessageRouting: that.savedMessage.IdMessageRouting
              }

              if (IdMessageRouting){
                params.IdMessageRouting = IdMessageRouting
              }
              that.$engine.firstOn().routing.message.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.message_deleted'))
                loadPage(that, {url: this.returnUrl})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editMessageRouting () {
      if (!this.validateFormOrAlert()) return
      this.editRouting()
    },
    editRouting () {
      if (!this.validateFormOrAlert()) return
      let that = this

      let flag = true
      if (this.role != 0 || this.type != 1) {
        if (this.configType === 'DATABASE') {
          this.configType = 'null'
        }
      }

      let configType

      if (this.entityType == 0){
        configType = this.arrayConfig[0].configType
      }

      if (this.entityType == 1){
        configType = this.arrayConfig[1].configType
      }

      if (this.entityType == 2){
        configType = this.arrayConfig[1].configType
      }

      if (this.entityType == 1 && this.entitiesType == 'decentralised'){
        configType = this.arrayConfig[1].configType
      }

      if (this.entitiesType === 'rvm') {
        if (this.arrayConfig[0].configType === 'WEBSERVICE' && this.arrayConfig[1].configType === 'null') {
          configType = 'WEBSERVICE'
        }
      }

      if (this.formHasError()) {
        return
      }

      let params = {
        IdAccountSelected: this.IdAccountSelected,
        Role: this.roleSelected,
        Type: this.typeSelected,
        // Message: this.message,
        ReceiverId: this.receiverId,
        MemberId: this.memberId,
        AcceptableErrorThreshold: this.acceptableErrorThreshold,
        RoutingName: this.routingName,
        Active: this.active,
        CertIdentifier: this.CertIdentifier,
        HeaderValue: this.HeaderValue,
        RoutingDescription: this.routingDescription,
        // IdFormat: this.idFormat,
        IdConfig: this.configId,
        RoutingType: configType,
        IdMessageRouting: this.arrayConfig[0].IdMessageRouting != '' ? this.arrayConfig[0].IdMessageRouting: this.arrayConfig[1].IdMessageRouting,
        IdBICGroup: this.IdBICGroup,
        entityType: this.entityType,
        CorporateIdentifierType: Object.values(this.corporateIdentifierType)
            .filter(status => status.state === 1)
            .map(item => item.value)
            .join(';'),
        BillableBic: this.billableBic,
        EntityCountry: this.entityCountry,
        EntityGroupCacp: this.entityGroupCacp,
        EntityTypeCacp: this.entityTypeCacp,
        ActivityProof: this.activityProof,
        ActivityProofStet: this.activityProofStet,
        ActivityProofEba: this.activityProofEba,
        SubscribedServices: Object.values(this.subscribedServices)
            .filter(srv => srv.state === 1)
            .map(item => item.value)
            .join(';'),
        UnitDdv: this.unitDdv,
        BulkDdv: this.bulkDdv
        // Standard: this.idStandard
      }

      switch (configType) {
        case 'INTERPROCESS':
          params.IdConfigInput = this.arrayConfig[0].configInterProcessId
          params.IdConfigOutput = this.arrayConfig[1].configInterProcessId
          break
        case 'MQSERIES':
          params.IdConfigInput = this.arrayConfig[0].configMQSeriesId
          params.IdConfigOutput = this.arrayConfig[1].configMQSeriesId
          break
        case 'REMOTEFOLDER':
          params.IdConfigInput = this.arrayConfig[0].configRemoteFolderId
          params.IdConfigOutput = this.arrayConfig[1].configRemoteFolderId
          break
        case 'WEBSERVICE':
          params.IdConfigInput = this.arrayConfig[0].configWebServiceId
          params.IdConfigOutput = this.arrayConfig[1].configWebServiceId
          break
        case 'S3':
          params.IdConfigOutput = this.arrayConfig[1].configS3Id
          break
        default:
          break
      }

      this.$engine.firstOn().routing.message.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.message_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: that.returnUrl})
      })
      .catch(e => {
        flag = false
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.routing.message_edition_error'))
      })

    },
    editModeActivate () {
      this.editMode = true
    },
    getDate (date) {
      if (!date || date == ''){
        return '-'
      }
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';
      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    fillFields () {
      this.role = this.savedMessage.Role
      this.BIC = this.savedMessage.ReceiverId
      this.BICParticipant = this.savedMessage.BICParticipant
      this.IdBICGroup = this.savedMessage.IdBICGroup
      this.type = this.savedMessage.Type !== undefined ? this.savedMessage.Type : this.type
      this.message = this.savedMessage.Message
      this.receiverId = this.savedMessage.ReceiverId
      this.memberId = this.savedMessage.MemberId
      this.acceptableErrorThreshold = this.savedMessage.AcceptableErrorThreshold
      this.idFormat = this.savedMessage.IdFormat
      this.configType = this.savedMessage.ConfigType
      this.routingName = this.savedMessage.RoutingName
      this.active = this.savedMessage.Active
      this.CertIdentifier = this.savedMessage.CertIdentifier
      this.OldCertIdentifier = this.savedMessage.CertIdentifier
      this.IdAccountSelected = this.savedMessage.IdAccount
      this.OldHeaderValue = this.savedMessage.HeaderValue
      this.HeaderValue = this.savedMessage.HeaderValue
      this.routingDescription = this.savedMessage.RoutingDescription
      this.billableBic = this.savedMessage.BillableBic
      this.entityCountry = this.savedMessage.EntityCountry
      this.entityGroupCacp = this.savedMessage.EntityGroupCacp
      this.entityTypeCacp = this.savedMessage.EntityTypeCacp
      this.creationDate = this.savedMessage.CreationDate
      this.modificationDate = this.savedMessage.ModificationDate
      this.serviceStartDate = this.savedMessage.ServiceStartDate
      this.deactivationDate = this.savedMessage.DeactivationDate
      this.activityProof = this.savedMessage.ActivityProof
      this.activityProofStet = this.savedMessage.ActivityProofStet
      this.activityProofEba = this.savedMessage.ActivityProofEba
      this.unitDdv = this.savedMessage.UnitDdv
      this.bulkDdv = this.savedMessage.BulkDdv
      this.statusDo = this.savedMessage.StatusDo
      this.arrayIdMessageRouting = []

      if(this.savedMessage.CorporateIdentifierType != undefined){
        for (let corporateIdentifierTypeKey in this.corporateIdentifierType) {
          if (this.savedMessage.CorporateIdentifierType.find((element) => element == this.corporateIdentifierType[corporateIdentifierTypeKey].value)) {
            this.corporateIdentifierType[corporateIdentifierTypeKey].state = 1
          }
        }
      }
      if(this.savedMessage.SubscribedServices != undefined){
        for (let subscribedServicesKey in this.subscribedServices) {
          if (this.savedMessage.SubscribedServices.find((element) => element == this.subscribedServices[subscribedServicesKey].value)) {
            this.subscribedServices[subscribedServicesKey].state = 1
          }
        }
      }

      let array = []
      this.savedMessage.Configs.forEach(element => {
        let item = {
          configType: element.ConfigType,
          IdMessageRouting :element.IdMessageRouting
        }

        switch (element.ConfigType) {
          case 'INTERPROCESS':
            item.configInterProcessId = element.IdConfig
            break
          case 'MQSERIES':
           item.configMQSeriesId = element.IdConfig
            break
          case 'REMOTEFOLDER':
           item.configRemoteFolderId = element.IdConfig
            break
          case 'WEBSERVICE':
           item.configWebServiceId = element.IdConfig
            break
          case 'S3':
           item.configS3Id = element.IdConfig
            break
          case 'FTP':
            item.configFTPId = element.IdConfig
            break
          default:
            break
        }
        array.push(item)
        this.arrayIdMessageRouting.push(element.IdMessageRouting)
      })
      this.arrayConfig = array

      // if (this.configType === "INTERPROCESS") {
      //   this.getInterProcessConfigs()
      //   this.configInterProcessId = this.savedMessage.IdConfig
      // }
      // if (this.configType === "MQSERIES") {
      //   this.getMQSeriesConfigs()
      //   this.configMQSeriesId = this.savedMessage.IdConfig
      // }
      // if (this.configType === "REMOTEFOLDER") {
      //   this.getRemoteFolderConfigs()
      //   this.configRemoteFolderId = this.savedMessage.IdConfig
      // }
      // if (this.configType === "WEBSERVICE") {
      //   this.getWebServiceConfigs()
      //   this.configWebServiceId = this.savedMessage.IdConfig
      // }
      // if (this.configType === "FTP") {
      //   this.getFTPConfigs()
      //   this.configFTPId = this.savedMessage.IdConfig
      // }

      this.selectRole()
    },
    formHasError () {
      if (this.entitiesType != 'decentralised'){
        // if(this.connectorHeaderExist()){
        //   if (this.HeaderValue.length === 0 && this.entityType == 0) {
        //     this.okMessageBox(this.$t('common.routing.header_value_missing'))
        //     return true
        //   }
        // }
      }
      if (this.flagCACP && (this.entitiesType == 'responder' || this.entitiesType == 'decentralised' || this.entitiesType == 'requester') && this.receiverId.length === 0) {
        this.okMessageBox(this.$t('common.routing.flagCACP.entity_bic_missing'))
        return true
      }
      else if (this.receiverId.length === 0) {
        this.okMessageBox(this.$t('common.routing.receiver_id_missing'))
        return true
      }
      if (this.IdAccountSelected.length === 0 && this.entitiesType != 'decentralised' && this.entityType !== 1) {
        this.okMessageBox(this.$t('common.routing.id_account_missing'))
        return true
      }
      if (this.routingName.length === 0) {
        this.okMessageBox(this.$t('common.routing.receiver_routing_name'))
        return true
      }
      if (this.active == '') {
        this.okMessageBox(this.$t('common.routing.routing_active_missing'))
        return true
      }
      if (this.OldCertIdentifier.length !== 0 && this.CertIdentifier.length === 0) {
        this.okMessageBox(this.$t('common.routing.certificat_identifier_missing'))
        return true
      }
      // if (this.entitiesType === 'rvm') {
      //   if (this.arrayConfig[0].configType !== "NULL" && this.arrayConfig[0].configType !== this.arrayConfig[1].configType) {
      //     // this.okMessageBox(this.$t('common.routing.config_type_same'))
      //     return true
      //   }
      // }
      let missingType = true
      let missingName = true
      let hasInvalidElement = false
      this.arrayConfig.some(element => {
        if (element.configType !== "null") {
          missingType = false
        }

        if (
            ((element.configWebServiceId !== '' ||
                    element.configMQSeriesId !== '' ||
                    element.configS3Id !== '' ||
                    element.configFTPId !== '') &&
                element.configType !== 'DATABASE') || element.configType === 'DATABASE'
        ) {
          missingName = false
        } else if (element.configType === 'NULL') {
          missingName = false
        }
      })
      if (missingType) {
        this.okMessageBox(this.$t('common.routing.config_type_missing'))
      }
      if (missingName) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
      }
      hasInvalidElement = missingType || missingName
      if (hasInvalidElement) {
        return false
      }
      if (this.entitiesType === 'decentralised' && this.acceptableErrorThreshold === 0) {
        this.okMessageBox(this.$t('common.routing.acceptable_error_threshold_missing'))
        return true
      }
      if (this.flagCACP && (this.entitiesType === 'responder' || this.entitiesType === 'decentralised' || this.entitiesType == 'requester') && this.billableBic.length === 0) {
        this.okMessageBox(this.$t('common.routing.flagCACP.billable_bic_missing'))
        return true
      }
      if (this.flagCACP && (this.entitiesType === 'responder' || this.entitiesType === 'decentralised') && this.entityCountry.length === 0) {
        this.okMessageBox(this.$t('common.routing.flagCACP.country_missing'))
        return true
      }
      if (this.flagCACP && (this.entitiesType === 'requester') && this.entityGroupCacp.length === 0) {
        this.okMessageBox(this.$t('common.routing.flagCACP.entity_type_missing'))
        return true
      }
      if (this.flagCACP && (this.entitiesType === 'requester') && this.entityTypeCacp.length === 0) {
        this.okMessageBox(this.$t('common.routing.flagCACP.entity_group.missing'))
        return true
      }
      // const bicRegex = /^[A-Za-z]{6,6}[A-Za-z2-9][A-NP-Za-np-z0-9]([A-Za-z0-9]{3,3}){0,1}?$/
      const bicRegex = /^[A-Za-z]{6}[A-Za-z2-9][A-NP-Za-np-z0-9][A-Za-z0-9]{3}$/
      if (this.flagCACP && (this.entitiesType === 'requester') && !bicRegex.test(this.receiverId)) {
        this.okMessageBox(this.$t('common.routing.flagCACP.entity_bic_invalid'))
        return true
      }
      if (this.flagCACP && (this.entitiesType === 'responder' || this.entitiesType === 'decentralised' || this.entitiesType === 'requester') && !bicRegex.test(this.billableBic)) {
        this.okMessageBox(this.$t('common.routing.flagCACP.billable_bic_invalid'))
        return true
      }
      if (this.flagCACP && (this.entitiesType === 'requester') && this.active === '1' && !Object.values(this.subscribedServices).some(srv => srv.state === 1)) {
        this.okMessageBox(this.$t('common.routing.flagCACP.activer_missing'))
        return true
      }
      if (this.flagCACP && (this.entitiesType === 'requester') && this.unitDdv === '' && (this.subscribedServices.UE.state === 1)) {
        this.okMessageBox(this.$t('common.routing.flagCACP.unitary_api_emission_consumer_missing'))
        return true
      }
      return false
    },
    connectorHeaderExist(){
      if(this.arrayConfig[0].configWebServiceId != '' && this.arrayConfig[0].configType == "WEBSERVICE"){
        let connectorSelected = this.webServiceListReceiver.find((element) => this.arrayConfig[0].configWebServiceId == element.IdWebService)
        if (connectorSelected){
          return true
        }
      }
      if(this.arrayConfig[1].configType == "S3"){
        let connectorSelected = this.S3ListReceiver.find((element) => this.arrayConfig[1].configS3Id == element.IdS3)
        if (connectorSelected){
          return true
        }
      }
      if(this.arrayConfig[0].configMQSeriesId != '' && this.arrayConfig[0].configType == "MQSERIES"){
        let connectorSelected = this.mqseriesListReceiver.find((element) => this.arrayConfig[0].configMQSeriesId == element.IdMQSeries)
        if (connectorSelected){
          return true
        }
      }
      return false
    },
    formHasErrorWithoutAlert () {
      if (this.entitiesType != 'decentralised') {
        // if(this.connectorHeaderExist()){
        // }
      }
      if (!this.receiverId || this.receiverId.length === 0) {
        return false
      }
      if (this.flagCACP && (this.entitiesType === 'responder' || this.entitiesType === 'decentralised' || this.entitiesType == 'requester') && this.billableBic.length === 0) {
        return false
      }
      if (this.flagCACP && (this.entitiesType === 'responder' || this.entitiesType === 'decentralised') && this.entityCountry.length === 0) {
        return false
      }
      if (this.flagCACP && (this.entitiesType === 'requester') && this.entityTypeCacp.length === 0) {
        return false
      }
      if ((!this.IdAccountSelected || this.IdAccountSelected.length === 0)&& this.entityType != 1) {
        return false
      }
      if (!this.routingName || this.routingName.length === 0) {
        return false
      }
      if (this.active == '') {
        return false
      }
      if (this.entitiesType === 'rvm') {
        if (this.arrayConfig[0].configType !== "NULL" && this.arrayConfig[1].configType !== "NULL" && this.arrayConfig[0].configType !== this.arrayConfig[1].configType) {
          this.okMessageBox(this.$t('common.routing.config_type_same'))
          return false
        }
      }
      let missingType = true
      let missingName = true
      let hasInvalidElement = false
      this.arrayConfig.some(element => {
        if (element.configType !== 'null') {
          missingType = false
        }

        if (
            ((element.configWebServiceId !== '' && element.configType == 'WEBSERVICE') ||
                    (element.configS3Id !== '' && element.configType == 'S3') ||
                    (element.configMQSeriesId !== '' && element.configType == 'MQSERIES') ||
                    (element.configFTPId !== '' && element.configType == 'FTP') &&
                element.configType !== 'DATABASE') || element.configType === 'DATABASE'
        ) {
          missingName = false
        } else if (element.configType === 'NULL') {
          missingName = false
        }
      })

      hasInvalidElement = missingType || missingName
      if (hasInvalidElement) {
        return false
      }
      if (this.entitiesType === 'decentralised' && this.acceptableErrorThreshold === 0) {
        this.okMessageBox(this.$t('common.routing.acceptable_error_threshold_missing'))
        return false
      }
      // if (this.flagCACP && (this.entitiesType === 'requester') && (this.unitDdv === '0' && this.bulkDdv === '0')) {
      //   this.okMessageBox(this.$t('common.routing.flagCACP.activer_missing'))
      //   return false
      // }
      // const bicRegex = /^[A-Za-z]{6,6}[A-Za-z2-9][A-NP-Za-np-z0-9]([A-Za-z0-9]{3,3}){0,1}?$/
      // if (this.flagCACP && (this.entitiesType === 'responder' || this.entitiesType === 'decentralised') && !bicRegex.test(this.billableBic)) {
      //   this.okMessageBox(this.$t('common.routing.flagCACP.billable_bic_invalid'));
      //   return false
      // }

      return true
    },
    getFormat () {
      let that = this
      this.$engine.firstOn().routing.format.fetch({
      })
      .then(resp => {
        this.formatList = resp.data.Formats

        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getBicGroup () {
      let that = this
      this.$engine.firstOn().bic.bicGroup.fetch({
      })
      .then(resp => {
        this.bicGroupList = resp.data.BicGroup
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getInterProcessConfigs () {
      let that = this
      this.$engine.firstOn().routing.config.interProcess.fetch({
      })
      .then(resp => {
        this.interProcessList = resp.data.InterProcesses

        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getMQSeriesConfigs () {
      let params = ''
      let that = this
      if (this.entitiesType !== 'rvm') {
        params = {entityType : this.entityType}
      } else {
        params = {entityType : this.entityType}
      }
      this.$engine.firstOn().routing.config.mqseries.fetch(
        params
      )
      .then(resp => {
        this.data.sender.mqseries = resp.data.MQSeriesConfig
        this.data.receiver.mqseries = resp.data.MQSeriesCredential

        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getRemoteFolderConfigs () {
      let that = this
      this.$engine.firstOn().routing.config.remoteFolder.fetch({
      })
      .then(resp => {
        this.remoteFolderList = resp.data.RemoteFolder

        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getWebServiceConfigs () {
      let params = ''
      let that = this
      if (this.entitiesType !== 'rvm') {
        params = { entityType : this.entityType }
      } else {
        params = { entityType : this.entityType }
      }
      this.$engine.firstOn().routing.config.webService.fetch(
        params
      )
      .then(resp => {
        this.data.sender.webservice = resp.data.WebServiceConfig
        this.data.receiver.webservice = resp.data.WebServiceCredentials

        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getS3Configs () {
      let  params = { entityType : 1, messageType:2, role: 0 }
      let that = this
      // if (this.entitiesType !== 'rvm') {
      //   params = { entityType : this.entityType }
      // } else {
      //   params = { entityType : this.entityType }
      // }
      this.$engine.firstOn().routing.config.s3.fetch(
        params
      )
      .then(resp => {
        this.data.sender.S3 = resp.data.S3Config
        this.data.receiver.S3 = resp.data.S3Config

        this.arrayConfig[1].configS3Id = resp.data.S3Config[0].IdConfigS3
        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        // errorMessageAlert(error, that)
      })
    },
    getFTPConfigs () {
      let params = ''
      let that = this
      if (this.entitiesType !== 'rvm'){
        params = { Role : this.role, Type : this.type }
      } else {
        params = { Role : this.roleSelected, Type : this.typeSelected }
      }
      this.$engine.firstOn().routing.config.FTP.fetch({
        params
      })
      .then(resp => {
        this.data.sender.ftp = resp.data.FTPConfig
        this.data.receiver.ftp = resp.data.FTPCredential

        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getRightsProfile () {
      let params = ''
      let that = this
      this.$engine.firstOn().rights.getAllProfilesLight()
      .then(resp => {

        if (!resp || !Array.isArray(resp.profiles)) {
          this.rightsProfile = []
          return
        }

        const groupedList = resp.profiles.reduce((acc, item) => {
          if (!acc.some(obj => obj.idAccount === item.idAccount && obj.accountName === item.accountName)) {
            acc.push({ idAccount: item.idAccount, accountName: item.accountName })
          }
          return acc
        }, [])

        this.rightsProfile = groupedList

        if (this.rightsProfile.length == 1) {
          this.IdAccountSelected = this.rightsProfile[0].idAccount
        }

        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
    },
    getUrl(){
      if (this.entitiesType === 'rvm'){
        this.entityType = 1
        this.returnUrl = '/entitiessettings/rvm/BICRVM'
      }
      if (this.entitiesType === 'requester'){
        this.entityType = 0
        this.returnUrl = '/entitiessettings/requester/Corporate'
      }
      if (this.entitiesType === 'responder'){
        this.entityType = 2
        this.returnUrl = '/entitiessettings/responder/SI'
      }
      if (this.entitiesType === 'decentralised'){
        this.entityType = 1
        this.returnUrl = '/entitiessettings/decentralised/SI'
        this.arrayConfig[1].configType = 'S3'
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    okMessageBoxError (message) {
      this.$f7.modal({
        text: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onChangeConfigType () {
      switch (this.configType) {
        case 'INTERPROCESS':
          this.getInterProcessConfigs()
          this.configMQSeriesId = 'null'
          this.configRemoteFolderId = 'null'
          this.configWebServiceId = 'null'
          this.configFTPId = 'null'
          break
        case 'REMOTEFOLDER':
          this.getRemoteFolderConfigs()
          this.configInterProcessId = 'null'
          this.configMQSeriesId = 'null'
          this.configWebServiceId = 'null'
          this.configFTPId = 'null'
          break
        case 'MQSERIES':
          this.configInterProcessId = 'null'
          this.configRemoteFolderId = 'null'
          this.configWebServiceId = 'null'
          this.configFTPId = 'null'
          break
        case 'WEBSERVICE':
          this.configInterProcessId = 'null'
          this.configMQSeriesId = 'null'
          this.configRemoteFolderId = 'null'
          this.configFTPId = 'null'
          break
        case 'FTP':
          this.configInterProcessId = 'null'
          this.configMQSeriesId = 'null'
          this.configRemoteFolderId = 'null'
          this.configWebServiceId = 'null'
          break
      }
      this.selectRole()
    }
  }
}
</script>
